import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/view/index'], resolve)
    },
    {
      path: '/babu_curriculum',
      name: 'babu_curriculum',
      component: resolve => require(['@/view/babu_curriculum'], resolve)
    },
    {
      path: '/library',
      name: 'library',
      component: resolve => require(['@/view/library'], resolve)
    },
    {
      path: '/Information_zone',
      name: 'Information_zone',
      component: resolve => require(['@/view/Information_zone'], resolve)
    },
    {
      path: '/Information_details',
      name: 'Information_details',
      component: resolve => require(['@/view/Information_details'], resolve),
      meta: {
        content: {
          keywords: '',
          description: ''
        }
      }
    },
    {
      path: '/national_special_zone',
      name: 'national_special_zone',
      component: resolve => require(['@/view/national_special_zone'], resolve)
    },
    {
      path: '/about_us',
      name: 'about_us',
      component: resolve => require(['@/view/about_us'], resolve)
    },
    {
      path: '/audition',
      name: 'audition',
      component: resolve => require(['@/view/audition'], resolve)
    },
    {
      path: '/apply',
      name: 'apply',
      component: resolve => require(['@/view/apply'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js